module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Ice-cream#2-c79a61641b3ff056c4fe477acb11d6da.svg";